const designSystem = {
  gallery: "Галерея",
  components: "Компоненты",
  handbook: "Справочник",
  searchComponents: "Поиск компонентов...",
  filterByCategory: "Фильтр по категории",
  allCategories: "Все категории",
  stable: "Стабильный",
  beta: "Бета",
  deprecated: "Устаревший",
  usedIn: "Используется в",
  dependenciesLabel: "Зависимости",
  propsLabel: "Props",
  filePath: "Путь к файлу",
  noResults: "Компоненты не найдены",
  totalComponents: "Всего компонентов",
  hasI18n: "i18n",
  hasCcId: "data-cc-id",
  catLayout: "Макет",
  catNavigation: "Навигация",
  catDataDisplay: "Отображение данных",
  catInput: "Ввод",
  catFeedback: "Обратная связь",
  catCanvas: "Канвас",
  catEditor: "Редактор",
  catWidget: "Виджет",
  registryOverview: "Обзор реестров",
  conventions: "Соглашения",
  componentAnatomy: "Анатомия компонента",
  addingComponent: "Добавление компонента",
  required: "Обязательно",
  optional: "Необязательно",
  expandDetails: "Развернуть детали",
  collapseDetails: "Свернуть детали",
  appPreview: "Превью приложения",
  previewDevice: "Устройство",
  previewPage: "Страница",
  previewNote: "Превью мобильного макета. Интерактивные элементы отключены.",
  library: "Библиотека",
  librarySearch: "Поиск компонентов...",
  libraryAll: "Все",
  libraryInstalled: "Только установленные",
  libraryInstalledBadge: "Установлен",
  libraryDocs: "Документация",
  libraryUse: "Копировать",
  libraryCopied: "Скопировано!",
  libraryShadcn: "shadcn/ui",
  libraryMagicUi: "Magic UI",
  library21st: "21st.dev",
  library21stNote: "21st.dev работает через поиск — здесь показаны 10 рекомендуемых компонентов. Для других попросите Claude найти в 21st.dev.",
  librarySync: "Синхронизация",
  libraryInstall: "Установить",
  libraryPreview: "Превью",
  libraryRefreshTitle: "Обновить каталог через AI",
  // Design System page inline text
  previewLabel: "Предпросмотр",
  backToGallery: "Назад в галерею",
  openNewTab: "Открыть в новой вкладке",
  openInTab: "Открыть во вкладке",
} as const;
export default designSystem;
